import { render, staticRenderFns } from "./PageSchoolCalendar.vue?vue&type=template&id=ba5c1362&scoped=true"
import script from "./PageSchoolCalendar.vue?vue&type=script&lang=js"
export * from "./PageSchoolCalendar.vue?vue&type=script&lang=js"
import style0 from "./PageSchoolCalendar.vue?vue&type=style&index=0&id=ba5c1362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c1362",
  null
  
)

export default component.exports